import { useTranslate } from 'core/hooks/useTranslate';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import LandingEdelvivesPlus from 'edelvives/modules/compositions/LandingEdelvivesPlus/LandingEdelvivesPlus';
import React from 'react';

const SupportView = () => {
  const { t } = useTranslate();
  return (
    <main className="about-view support-view" id={MAIN_CONTENT_ID} tabIndex={-1}>
      <h1 className="sr-only">{t('titles:Support')}</h1>
      <div className="about-view__wrapper">
        <LandingEdelvivesPlus />
        <div className="about-view__contact">Para cualquier soporte que necesites por favor contacta con nosotros en info@edelvives.es</div>
      </div>
    </main>
  );
};

export default SupportView;
